var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4629_58672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0678 44.2666H41.3678V68.2666C41.3678 71.7999 45.7678 73.4666 48.1011 70.7999L73.3344 42.1332C75.5344 39.6332 73.7678 35.7332 70.4344 35.7332H60.1344V11.7332C60.1344 8.1999 55.7344 6.53323 53.4011 9.1999L28.1678 37.8666C26.0011 40.3666 27.7678 44.2666 31.0678 44.2666Z",
    fill: "#2A8DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 15.8335H5C3.63333 15.8335 2.5 14.7002 2.5 13.3335C2.5 11.9668 3.63333 10.8335 5 10.8335H28.3333C29.7 10.8335 30.8333 11.9668 30.8333 13.3335C30.8333 14.7002 29.7 15.8335 28.3333 15.8335Z",
    fill: "#C1E4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 69.1665H5C3.63333 69.1665 2.5 68.0332 2.5 66.6665C2.5 65.2998 3.63333 64.1665 5 64.1665H25C26.3667 64.1665 27.5 65.2998 27.5 66.6665C27.5 68.0332 26.3667 69.1665 25 69.1665Z",
    fill: "#C1E4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 42.5H5C3.63333 42.5 2.5 41.3667 2.5 40C2.5 38.6333 3.63333 37.5 5 37.5H15C16.3667 37.5 17.5 38.6333 17.5 40C17.5 41.3667 16.3667 42.5 15 42.5Z",
    fill: "#C1E4F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4629_58672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuick);
export default __webpack_public_path__ + "static/media/quick.413a2f45f249a9ed5973010e7ba08506.svg";
export { ForwardRef as ReactComponent };